<template>
  <div class="userData">
    <router-link to="/" class="logo app-logo">
      <img src="https://img01.wanfangche.com/assets/21rv-logo-article.png" alt="" />
    </router-link>
    <div class="middle ">
      <el-button class="hidden-sm" icon="el-icon-edit-outline" type="primary" round size="small"><router-link
          to="/article/create?type=1" class=" text-white">写文章</router-link></el-button>
    </div>
    <div class="user">
      <el-button icon="el-icon-bell" class="border-none bell position-relative" @click="$router.push({name: 'Notification'})">
        <span class=" position-absolute notice" v-show="noticeNum > 0">{{ noticeNum < 100 ? noticeNum : '99+' }}</span>
      </el-button>
      <el-popover placement="bottom" width="100" trigger="hover" v-model="isShow" class="m-w-none">
        <ul class="user-menu">
          <li>
            <b>{{ userData.nickname }}</b>
          </li>
          <li><router-link :to="{ path: '/account/' }">账户设置</router-link></li>
          <li @click="onExit">退出登录</li>
        </ul>
        <div class="avatar" @mousedown="isShow = true" slot="reference">
          <el-image fit="cover" :src="userData.avatar
            ? userData.avatar + '?x-oss-process=style/small'
            : 'https://img01.wanfangche.com/assets/avatar.png'
            " alt="" slot="reference"></el-image>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import NoticeService from '../../service/NoticeService';
import {
  mapActions, mapGetters, mapState
} from "vuex";
export default {
  data() {
    return {
      isShow: false,
      timer: null,
    };
  },
  computed: {
    userData: () => store.getters.currentUser,
    ...mapState({
      noticeNum: state => state.noticeNum
    })
  },
  methods: {
    ...mapActions(["doLogout"]),
    onExit() {
      this.doLogout();
      this.$router.replace("/login");
    },
  },
  created() {
    this.timer = NoticeService.loop()
  },
  destroyed() {
    NoticeService.stopLoop()
  }
};
</script>

<style lang="scss" scoped>
.user-menu {
  width: 100%;

  li {
    width: 100%;
    height: auto;
    padding: 5px 0;
    text-align: center;
    cursor: pointer;
  }
}

.notice {
  font-size: 12px;
  color: #fff;
  background: red;
  transform: scale(0.8);
  right: 16px;
  top: 4px;
  padding: 3px;
  border-radius: 20px;
  min-width: 18px;
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.userData {
  max-width: 1320px;
  height: 60px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .middle {
    flex: 1;
    margin-left: 20px;

    button {
      width: 100px;
    }
  }

  .logo {
    width: 180px;
    margin-left: 20px;
  }

  .title {
    font-weight: 800;
    font-size: 16px;
    margin-left: 10px;
  }

  .user {
    display: flex;
    align-items: center;

    .bell {
      font-size: 20px;
      margin-right: 10px;
    }

    .avatar {
      width: 32px;
      height: 32px;
      overflow: hidden;
      border-radius: 16px;
    }
  }

  img {
    width: 100%;
  }
}

@media (max-width: 991.98px) {
  .userData {
    .logo {
      overflow: hidden;
      margin-left: 0;

      img {
        width: auto;
        height: 26px;
      }
    }
  }
}
</style>
